import React, { useState, useRef, useEffect } from 'react';
import './TrustBadge.css';
import { IconCheck } from './Icons';

export function DataClassificationBadge({ type = 'live' }) {
  const configs = {
    live: { label: 'Live Data', tag: 'UDYAM LIVE', className: 'badge-live' },
    historical: { label: 'Historical Record', tag: 'CENSUS 10Y', className: 'badge-historical' },
    census: { label: 'Census Record', tag: 'CENSUS 10Y', className: 'badge-historical' },
    ml: { label: 'Predicted (24M)', tag: 'ML OUTLOOK', className: 'badge-forecast' },
    forecast: { label: 'Predicted (24M)', tag: 'ML OUTLOOK', className: 'badge-forecast' },
  };

  const config = configs[type] || configs.live;

  return (
    <span className={`data-class-badge ${config.className}`} title={`${config.label} verified source`}>
      <span className="data-class-dot" />
      <span className="data-class-tag">{config.tag}</span>
    </span>
  );
}

export function TrustLayerPopover({ district = 'all', freshnessText = 'Live Synced' }) {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleOutside);
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  return (
    <div className="trust-layer-wrap" ref={popoverRef}>
      <button 
        type="button"
        className="trust-trigger-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-label="View Data Trust & Verification Metrics"
      >
        <span className="trust-shield"><IconCheck width={13} height={13} /></span>
        <span className="trust-label">Verified Data: <strong>99.9%</strong></span>
        <span className="trust-info-icon">ⓘ</span>
      </button>

      {isOpen && (
        <div className="trust-popover" role="dialog" aria-label="Trust Metrics Details">
          <div className="trust-popover-header">
            <h4>Where Does This Data Come From?</h4>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.45rem' }}>
              <span className="trust-popover-badge">99.9% Verified</span>
              <button
                type="button"
                className="trust-popover-close-btn"
                onClick={() => setIsOpen(false)}
                aria-label="Close"
              >
                ✕
              </button>
            </div>
          </div>

          <div className="trust-metrics-list">
            <div className="trust-metric-row">
              <span className="trust-metric-name">Official Source</span>
              <strong className="trust-metric-val">Ministry of MSME (Official Udyam Registry)</strong>
            </div>
            <div className="trust-metric-row">
              <span className="trust-metric-name">Data Accuracy</span>
              <strong className="trust-metric-val text-emerald">99.9% Verified Govt Records</strong>
            </div>
            <div className="trust-metric-row">
              <span className="trust-metric-name">Last Updated</span>
              <strong className="trust-metric-val">{freshnessText} (Live Updates)</strong>
            </div>
            <div className="trust-metric-row">
              <span className="trust-metric-name">Industry Categories</span>
              <strong className="trust-metric-val">Official NIC National Business Categories</strong>
            </div>
            <div className="trust-metric-row">
              <span className="trust-metric-name">System Uptime</span>
              <strong className="trust-metric-val">Always Online (99.98% Uptime)</strong>
            </div>
          </div>

          <div className="trust-popover-footer">
            <span>Directly verified with official government filings · Lysarq Solutions</span>
          </div>
        </div>
      )}
    </div>
  );
}
